import _ from 'lodash';
import moment from 'moment';

require('moment-duration-format');

const reducers = {
    history (res, req) {
        const _status = {
            0: '0%', // none
            1: '100%' // success
        };

        const createdAt = moment(res.DataInicio).toDate();
        let finishedAt;
        let duration;

        if (res.DataFim) {
            finishedAt = moment(res.DataFim).toDate();
            const timeDiff = Math.abs(finishedAt.getTime() - createdAt.getTime()) / 1000;
            duration = moment.duration(timeDiff, 'seconds').format('HH:mm:ss', { trim: false });
        }

        return ({
            status: res.Status,
            created_at: createdAt,
            finished_at: finishedAt,
            duration,
            date: req.date,
            id: res.IdRelatorio,
            documents: _.map(res.Arquivos, (r, i) =>
                ({
                    extension: _.replace(r.Arquivo, /^.*\./, ''),
                    name: _.replace(r.Arquivo, /\.[0-9a-z]+$/, ''),
                    fullname: r.Arquivo,
                    id: i,
                    date: r.Data ? moment(r.Data, 'DD/MM/YYYY').toDate() : moment(req.date, 'YYYY/MM/DD').toDate(),
                    status: _status[r.Status],
                    optional: !r.Obrigatorio
                })
            )
        });
    },

    family (res) {
        return _.map((res), r =>
            ({
                id: r.Id,
                name: r.Nome,
                price: r.PrecoPublico.toFixed(2),
                model: r.ModeloPesquisado,
                legend: r.ModeloLegenda || r.ModeloPesquisado
            })
        );
    },

    errors (res) {
        return _.map(res, r =>
            _.reduce(r.Sheets, (result, val, key) => {
                if (_.isArray(val)) {
                    _.forEach(val, (v) => {
                        result.push({
                            document: r.Document,
                            tab: key,
                            actualColumn: v.ActualColumn,
                            columnSequence: v.ColumnSequence,
                            expectedColumn: v.ExpectedColumn
                        });
                    });
                }

                return result;
            }, [])
        );
    },

    models (res, req) {
        return _.map((res), r =>
            ({
                id: r.Id,
                name: r.Nome,
                alias: r.NomeSufixo,
                series: r.IdSerie,
                family: {
                    id: req.id,
                    name: req.name
                }
            })
        );
    },

    series (res, req) {
        return _.map((res), r =>
            ({
                id: r.Id,
                name: r.Nome,
                family: {
                    id: req.id,
                    name: r.Familia || req.name
                }
            })
        );
    }
};

export default reducers;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/upload/reducers.js